<template>
    <Breadcrumbs main="Categories" :mains="title" title="Accueil" />
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12">
                <ReportCategoryEdit :reportCategory="reportCategory" />
                <div class="row">
                    <div class="col">
                        <div class="text-end">
                            <a
                                class="btn btn-success me-1"
                                target="_blank"
                                @click="save()"
                                >{{ $t('save') }}</a
                            >
                        </div>
                    </div>
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useRoute } from 'vue-router';
let route = useRoute();
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { error_message, success_message } from '@/components/common/toast';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import type { reportCategory } from '@/core/data/reportCategory';
const { t } = useI18n();
const ReportCategoryEdit = defineAsyncComponent(
    () => import('@/components/theme/report/ReportCategoryEdit.vue'),
);
let reportCategory = ref<reportCategory>({
    title: '',
    imageUrl: undefined,
    categoryIcon: undefined,
    status: 'CREATED',
    createdBy: undefined,
    createdAt: undefined,
    updatedBy: undefined,
    updatedAt: undefined,
});

const title = computed(() => {
    return reportCategory.value && reportCategory.value.id
        ? t('reportCategoryEdit.updatetitle')
        : t('reportCategoryEdit.addtitle');
});
const save = async () => {
    if (!reportCategory.value.title) {
        error_message(t('reportCategoryEdit.titleRequired'));
        return;
    }
    useLoaderState().changeStateTrue();
    if (route.query.id !== undefined) {
        //@ts-ignore
        ApiServices.update(
            'reportCategories',
            reportCategory.value,
            reportCategory.value.id,
        )
            .then(() => {
                success_message(t('reportCategoryEdit.updated'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    } else {
        ApiServices.create('reportCategories', reportCategory.value)
            .then(() => {
                success_message(t('reportCategoryEdit.saved'));
            })
            .catch((ex) => {
                error_message(ex);
            })
            .finally(() => {
                useLoaderState().changeStateFalse();
            });
    }
};
const getDatas = async () => {
    if (route.query.id !== undefined) {
        ApiServices.getById('reportCategories', route.query.id.toString()).then(
            (response: any) => {
                reportCategory.value = response;
            },
        );
    }
};
onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas();
    useLoaderState().changeStateFalse();
});
</script>
